// Thin client over the per-user sidebar-theme API.
//   GET /auth/sidebar-theme/  → { theme }
//   PUT /auth/sidebar-theme/  → { success, theme }
//
// Kept separate from navigationLayoutService on purpose: the menu-layout editor
// PUTs a whole layout and knows nothing about themes, so sharing one endpoint
// would let each surface clobber the other's field.

import api from './api';
import { SidebarThemeId, coerceSidebarTheme } from '../config/sidebarThemes';

interface ThemeResponse {
  theme: string;
}

interface SaveThemeResponse {
  success: boolean;
  theme: string;
}

export const sidebarThemeService = {
  async get(): Promise<SidebarThemeId> {
    const res = await api.get<ThemeResponse>('/auth/sidebar-theme/');
    return coerceSidebarTheme(res?.theme);
  },

  async save(theme: SidebarThemeId): Promise<SidebarThemeId> {
    const res = await api.put<SaveThemeResponse>('/auth/sidebar-theme/', { theme });
    return coerceSidebarTheme(res?.theme ?? theme);
  },
};

export default sidebarThemeService;
